export const CURRENT_USER = 'currentUser';
export const USER_REMEMBER = 'userRemember';
export const VALID_OTP_CODE = 'validOtpCode';
